import { cleanse } from 'utils';

import { bruttoProdStatusValues } from '../contactList/constants';

export const bodyFactory = (keyWindow, formData, withProduction, calculateBruttoProduction) => {
	const {
		campaign,
		channel,
		region,
		agency,
		manager,
		seller,
		ppz,
		contactState = [],
		surname,
		firstName,
		personIn,
		businessIn,
		businessName,
		product,
		municipality,
		zipCode,
		policyNumber,
		proposalNo,
		currentRole,
		campaignStateIds,
		searchAllCampaigns,
		isForDashboard,
		dashboardContactSite,
		filterNominations,
		bruttoProductionStatus,
	} = formData;

	return cleanse({
		calculateBruttoProduction,
		withProduction,
		campaignId: campaign,
		orgStruct: {
			channelId: channel,
			regionId: region,
			agencyIds: agency ? [agency] : [],
			manager,
			seller,
			ppz,
		},
		businessName,
		clientSurname: surname,
		clientName: firstName,
		userRole: currentRole,
		personIn,
		businessIn,
		productName: product,
		municipality,
		zipCode,
		policyNo: policyNumber,
		proposalNo,
		solutionStateIds: Array.isArray(contactState) ? contactState : [contactState],
		campaignStateIds,
		searchAllCampaigns,
		isForDashboard,
		dashboardContactSite,
		filterNominations,
		...(keyWindow === 'list' && { bruttoPairedFilter: bruttoProductionStatus || bruttoProdStatusValues.DEFAULT }),
	});
};
